import { Requirements } from 'app/routes';

import {
    CrmActivityState,
    Owner,
    setCrmActivityDescription,
    setCrmActivityLimit,
    setCrmActivityListOwners,
    setCrmActivityOwners,
    setCrmActivityTitle,
    setCrmId,
} from 'store/models/crmActivity';

const CrmActivityRequirements: Requirements<{
    crmActivity: CrmActivityState;
    listOwners: Owner[];
}> = {
    methods: ({ match }) => ({
        crmActivity: { url: `/api/v1/crm/activity/${match?.params.crmId || ''}`, cacheable: false },
        listOwners: { url: '/api/v1/crm/activity/owners', cacheable: false },
    }),
    resolve: ({ result: { crmActivity, listOwners }, match }) => {
        const crmId = match?.params.crmId || '';
        const { title, description, dailyLimit, owners } = crmActivity;
        return [
            setCrmActivityTitle(title),
            setCrmActivityDescription(description),
            setCrmActivityLimit(`${dailyLimit}` || ''),
            setCrmActivityOwners(owners),
            setCrmActivityListOwners(listOwners),
            setCrmId(crmId),
        ];
    },
};

export default CrmActivityRequirements;
